import * as THREE from "three";
import Card from "@/models/Memoram/Card";
import Background from "@/models/Memoram/Background";
import Board from "@/models/Memoram/Board";
import MainLight from "@/models/Memoram/MainLight";
import SecondaryLight from "@/models/Memoram/SecondaryLight";

export default function(questions, answers, camera, container, vueBus) {
  // Raiz entera mas cercana por arriba de foo
  function closestRoot(number) {
    let root = number ** 0.5;

    while (root % 1 !== 0) {
      number++; // MODULE TO 1 IS 0, IS A CUADRATIC NUMBER, OTHERWISE KEEP FINDING IT
      root = number ** 0.5;
    }

    return number ** 0.5;
  }

  const scene = new THREE.Scene();
  const textureLoader = new THREE.TextureLoader();

  const cardWidth = 3;
  const cardHeight = 5;
  const cardNumber = questions.length;
  const cardNumberRounded = closestRoot(questions.length);
  const boardSize = cardNumberRounded * cardHeight + cardNumberRounded; // Tamaño de tablero acorde a valor mas cercano con raiz entera, obtenida de la función "closestRoot"

  const staticPositionCardX = (cardWidth - boardSize) / 2;
  const staticPositionCardY = (boardSize - cardHeight) / 2;
  const distancefromBoard = boardSize * 3;

  // Answer cards
  let aux = 0;
  for (let i = 0; i < boardSize; i++) {
    for (let j = 0; j < boardSize; j++) {
      if (aux < cardNumber) {
        if ((j === 0 || (j > 0 && j % 6 === 0)) && (i === 0 || (i > 0 && i % 6 === 0))) {
          const card = new Card(
            staticPositionCardX + (j + 1.5) + distancefromBoard,
            staticPositionCardY - (i + 0.5),
            0.25,
            cardWidth,
            cardHeight,
            boardSize,
            answers[aux].id,
            answers[aux].text,
            "#ffffff",
            answers[aux].path,
            "/img/3DTextures/memoram/game/frontAnswer.jpg",
            "/img/3DTextures/memoram/game/backAnswer.jpg",
            "answer",
            aux,
            camera,
            textureLoader
          );
          scene.add(card);
          aux++;
        }
      }
    }
  }

  // Question cards
  aux = 0;
  for (let i = 0; i < boardSize; i++) {
    for (let j = 0; j < boardSize; j++) {
      if (aux < cardNumber) {
        if ((j === 0 || (j > 0 && j % 6 === 0)) && (i === 0 || (i > 0 && i % 6 === 0))) {
          const card = new Card(
            staticPositionCardX + (j + 1.5),
            staticPositionCardY - (i + 0.5),
            0.25,
            cardWidth,
            cardHeight,
            boardSize,
            questions[aux].id,
            questions[aux].text,
            "#00ffff",
            questions[aux].path,
            "/img/3DTextures/memoram/game/frontQuestion.jpg",
            "/img/3DTextures/memoram/game/backQuestion.jpg",
            "question",
            aux,
            camera,
            textureLoader
          );
          scene.add(card);
          aux++;
        }
      }
    }
  }

  // Background
  const background = new Background(boardSize * 1.5, 0, 0, boardSize * 10, camera, textureLoader);

  // Answer board
  const answerBoard = new Board(boardSize * 3, 0, 0, boardSize, textureLoader);
  const answerLight = new SecondaryLight(0xffffff, boardSize);

  // Question board
  const questionBoard = new Board(0, 0, 0, boardSize, textureLoader);
  const questionLight = new MainLight(
    0xffffff,
    boardSize,
    cardNumber,
    answerLight,
    camera,
    scene,
    container,
    vueBus
  );

  scene.add(background);
  scene.add(answerBoard);
  scene.add(answerLight);
  scene.add(questionBoard);
  scene.add(questionLight);

  camera.position.set(0, 0, boardSize / 1.25);
  camera.lookAt(questionBoard.position);

  return scene;
}
